// @ts-nocheck

import React, { useState, useLayoutEffect } from 'react';
import styled from 'styled-components';

import { Target } from '../../../../client';
import CurrencyExposant from '../CurrencyExposant';

const Progress = styled.div`
  position: relative;
  width: 100%;
  height: 0.4em;
  text-align: left;
  background-color: ${({ theme }) => theme.grids.colors.lightgrey};
  border-radius: 0.2em;
  overflow: hidden;
`;

const Bar = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  transition: transform 1s linear;
  transform: scale(${({ $value }) => $value}, 1);
  transform-origin: 0 center;
  background-color: ${({ theme }) => theme.grids.colors.redlight};
`;

const Label = styled.span`
  font-weight: bold;
  white-space: nowrap;
  font-size: ${Target.__MOBILE__ ? '1.2em' : '1.5em'};
`;

const Red = styled.span`
  color: ${({ theme }) => theme.grids.colors.redlight};
`;

type Props = {
  className?: string;
  value: number;
  max: number;
};

const ProgressBar = ({ className, value, max }: Props) => {
  const [animValue, setAnimValue] = useState(0);

  useLayoutEffect(() => {
    if (value) {
      setAnimValue(value);
    }
  }, [value]);

  return (
    <div className={className}>
      <Label>
        <CurrencyExposant amount={value} /> <Red>/</Red> <CurrencyExposant amount={max} />
      </Label>
      <Progress>
        <Bar $value={animValue / max} />
      </Progress>
    </div>
  );
};

export default ProgressBar;
